import { AmenityViewModel, RoomViewModel, ViewModel } from 'src/common/models';

import { mapImages } from './property-info-adapter';

export const hasRooms = (response: any) => Boolean(response?.data?.propertyInfo?.offers?.units);

export const adaptRooms = (response: any, rooms: RoomViewModel[]): RoomViewModel[] => {
  if (!hasRooms(response)) {
    return rooms;
  }

  //No need to null check, since this is handled by hasRooms already
  const units = response.data.propertyInfo.offers.units;

  return units.map((room, index) => adaptRoom(room, rooms[index]));
};

export const adaptRoom = (room, bffRoom): RoomViewModel => {
  if (!room) {
    return bffRoom;
  }

  return {
    ...bffRoom, //While we're still migrating fields, default in the BFF data, then override with BexApi
    beddingOptions: room.bedOptions,
    roomAmenities: adaptAmenities(room.features),
    description: room.description,
    name: room.header?.text,
    view: adaptViewModel(room.header),
    roomTypeCode: room.id,
    roomSize: room.size,
    udpUrl: room.bookingUrl,
    expandRatePlansLabel: adaptRatePlansExpando(room),
    photos: room.gallery.map(mapImages)
  };
};

export const adaptRatePlansExpando = (room): string => room?.ratePlansExpando?.expandButton.text || null;

export const adaptAmenities = (roomFeatures): AmenityViewModel[] => (roomFeatures ? roomFeatures.map(adaptAmenity) : []);

export const adaptAmenity = (roomFeature): AmenityViewModel => ({
  description: roomFeature.text,
  category: (roomFeature.icon && roomFeature.icon.id) || ''
});

export const adaptViewModel = (header): ViewModel =>
  header && {
    description: header.subText
  };
